import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgHelmetModule} from 'ng-helmet';
import {MatIconModule} from '@angular/material/icon';

import {RecruiterProgramRoutingModule} from './recruiter-program-routing.module';
import {I18nModule} from '../i18n/i18n.module';
import {FooterModule} from '../footer/footer.module';

import {RecruiterProgramComponent} from './recruiter-program.component';
import {RpHeaderComponent} from './components/rp-header/rp-header.component';
import {HeroSectionComponent} from './components/hero-section/hero-section.component';
import {TrustedBySectionComponent} from './components/trusted-by-section/trusted-by-section.component';
import {TargetAudienceSectionComponent} from './components/target-audience-section/target-audience-section.component';
import {ServicesSectionComponent} from './components/services-section/services-section.component';
import {
  AdvancedFeaturesSectionComponent
} from './components/advanced-features-section/advanced-features-section.component';
import {WhyUsSectionComponent} from './components/why-us-section/why-us-section.component';
import {CtaSectionComponent} from './components/cta-section/cta-section.component';
import {IconComponent} from "../shared/components/icon/icon.component";
import {ResponsiveImgComponent} from "../shared/components/responsive-img/responsive-img.component";
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    RecruiterProgramComponent,
    RpHeaderComponent,
    HeroSectionComponent,
    TrustedBySectionComponent,
    TargetAudienceSectionComponent,
    ServicesSectionComponent,
    AdvancedFeaturesSectionComponent,
    WhyUsSectionComponent,
    CtaSectionComponent,
  ],
  imports: [
    CommonModule,
    FooterModule,
    RouterModule,
    NgHelmetModule,
    MatIconModule,
    IconComponent,
    ResponsiveImgComponent,
    TranslateModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RecruiterProgramModule {}
